import "./Navbar.css";
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";

import BreadcrumbsNav from "@common-components/BreadcrumbsNav/BreadcrumbsNav";
import { AuthContext } from "@contexts/AuthContext";
import { logoutAuth } from "@libs/apiRequest.js";

const Navbar = () => {
  const navigate = useNavigate();
  const { currentUser, currentUserRole, updateUser } = useContext(AuthContext);

  return (
    <nav className="Navbar__container">
      <Link to="/" className="Navbar__logo--link">
        {currentUserRole === "SALES" ||
        currentUserRole?.startsWith("SALES_") ? (
          <img
            src={`${process.env.PUBLIC_URL}/logo/MattamyLogo.svg`}
            alt="Mattamay Homes Logo"
            className="Navbar__logo--MattamyImg"
          />
        ) : currentUserRole ? (
          <img
            // src={`${process.env.PUBLIC_URL}/BIMstudio_New_Logo_Rectangle.png`}
            src={`${process.env.PUBLIC_URL}/logo/BIMstudioLogo.svg`}
            alt="BIMstudio Logo"
            className="Navbar__logo--BIMstudioImg"
          />
        ) : (
          <div className="Navbar__logo--placeholder"></div>
        )}
      </Link>

      <BreadcrumbsNav />
      {currentUser ? (
        <LogoutIcon
          className="Navbar__button--logout"
          onClick={async () => {
            logoutAuth();
            await updateUser("");
            localStorage.removeItem("projectSelection");
            localStorage.removeItem("modelSelection");
            localStorage.removeItem("user");
            navigate("/home/login");
          }}
        />
      ) : (
        <LoginIcon
          className="Navbar__button--login"
          onClick={() => navigate("/home/login")}
        />
      )}
    </nav>
  );
};

export default Navbar;
